import { useEffect, useState } from 'react';
import { matchPath } from 'react-router';
import { PlayerRoutes, PlayerRouteToAssetType } from 'types/RouteTypes';
import { PlayerLocationParams, PlayerProps, PlayingAssetType } from 'types/Player';
import { useWrapLocation } from './useWrapRouter/useWrapLocation';

export const playerRouteMatch = (path: string): PlayerProps => {
    let match = null;
    let type: PlayingAssetType = null;

    Object.getOwnPropertyNames(PlayerRoutes).forEach((route) => {
        const matchByRoute = matchPath(PlayerRoutes[route], path);

        if (matchByRoute) {
            match = matchByRoute;
            type = PlayerRouteToAssetType[route] ?? null;
        }
    });

    return {
        type,
        params: match?.params ?? {},
    };
};

export const getPlayerPropsForUrl = (url: string): PlayerProps => {
    if (!url) {
        return null;
    }

    const playerProps = playerRouteMatch(url.split(/[?#]/)[0]);

    return playerProps.type ? playerProps : null;
};

export const usePlayerRouter = () => {
    const { pathname } = useWrapLocation();
    const [params, setParams] = useState<PlayerLocationParams>();
    const [playerType, setPlayerType] = useState<PlayingAssetType>(null);

    useEffect(() => {
        const { type, params: routeParams } = playerRouteMatch(pathname);

        setParams(routeParams);
        setPlayerType(type ?? null);
    }, [pathname]);

    return {
        params,
        playerType,
    };
};
